<template>
    <div v-if="this.page">
        <i class="fa-regular fa-gear fa-lg cursor-pointer" @click="showSettingsModal" />
    </div>
</template>

<script>
    export default {
        computed: {
            page() {
                const path = window.location.pathname;

                if (path === '/') return 'dashboard';

                if (path.startsWith('/content/template/edit')) return 'creator';
                if (path.startsWith('/content/campaign/edit')) return 'creator';
                if (path.startsWith('/content/publish')) return 'creator';

                return null;
            }
        },
        methods: {
            showSettingsModal() {
                EaseEventBus.fire('showModal', this.page + '-settings')
            }
        }
    }
</script>
